export default {
	headers: {
		general: {
			patient: "Patient",
			options: "Options",
			attach: "Attach",
			alert_history: "Alert history",
			resume: "Resume",
			readings: "Readings",
			notifications: "Notifications",
			report: "Report",
			reports: "Reports",
			attach_device: "Attach device",
			reading: "Reading",
			position: "Position",
			zone: "Zone",
			pillbox: "Pill box",
			add_pill: "Add pill",
			edit_pill: "Edit pill",
			healthreports: "Health reports",
			medicaldocuments: "Medical documents",
			edit_configs: "Edit configurations",
			history: "History",
			response: "Response",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/headers/headers_en-gb.js